import { i18n } from '@goodboydigital/astro';
import gsap from 'gsap';
import { ITextStyle, Text, TextStyle } from 'pixi.js';

import { Game } from '../game/Game';
import { Random } from '../utils/Random';
import LocalisedText, { LocalisedTextOptions } from './LocalisedText';
import { Widget } from './Widget';

const defaultStyle = {
    fill: 'white',
    align: 'center',
    fontSize: 130,
    fontFamily: 'lubalin',
    lineJoin: 'round',
    stroke: 0x333333,
    strokeThickness: 20,
    maxWidth: 300,
    maxHeight: 150
};

const crashStyle = {
    align: 'center',
    fontSize: 130,
    fontFamily: 'lubalin',
    lineJoin: 'round',
    stroke: 0xFFFFFF,
    strokeThickness: 20,
    maxWidth: 300,
    maxHeight: 150
};

const crashColors = [
    0xFF45BE,
    0xFFD200,
    0x008AFF,
    0xFF4E00,
    0x9DDE00,
];

export class MessageWidget extends Widget
{
    private label!: LocalisedText;
    public game: Game;
    private timeout?: any;

    constructor(game: Game)
    {
        super();
        this.game = game;
    }

    protected async build(): Promise<void>
    {
        if (this.label) return;
        this.label = new LocalisedText('0', defaultStyle as Partial<LocalisedTextOptions>);
        this.label.anchor.set(0.5);
        this.view.addChild(this.label);
    }

    public show(text: string, scale = 1, autoCloseAfter = 2): void
    {
        this.open();
        this.clearScheduledClose();
        this.label.style = defaultStyle as Partial<TextStyle>;
        this.label.text = text;
        this.label.scale.set(scale);
        this.scheduleClose(autoCloseAfter);
    }

    public showCrash(): void
    {
        this.open();
        this.clearScheduledClose();
        this.label.style = crashStyle as Partial<TextStyle>;
        this.label.style.fill = Random.pick(...crashColors);
        this.label.setText(`game_crash${Math.round(Random.range(1, 5))}`);
        gsap.to(this.label.scale, { duration: 0.6, x: this.label.scale.x * 0.6, y: this.label.scale.y * 0.6, ease: 'Bounce.easeOut' });
        this.scheduleClose(2);
    }
    
    public showWheelieWarning(): void
    {        
        this.open();
        this.clearScheduledClose();
        this.label.style = { ...defaultStyle as Partial<TextStyle>, ...{ wordWrap: true, wordWrapWidth: 1000 } };
        this.label.setText('game_prepareWarning');
        this.scheduleClose(4);
    }

    protected async onClose(): Promise<void>
    {
        this.clearScheduledClose();
    }

    private scheduleClose(after: number): void
    {
        this.clearScheduledClose();
        this.timeout = setTimeout(() => this.close(), after * 1000);
    }

    private clearScheduledClose(): void
    {
        clearTimeout(this.timeout);
        this.timeout = null;
    }
}
